<template>
	<!-- core application -->
	<div id="mylucasfox" v-if="ok">
		<div class="c-section-cp">
			<div class="wrapper">

				<welcome :customername="customername" :stronglylinked="stronglylinked" :customerthumbnail="customerthumbnail"></welcome>

				<modal v-bind="modal" v-on:closeModal="closeModal" />
				<vue-tabs @tab-change="handleTabChange" :value="this.tabidx">
					<v-tab :title="$t('recents.title')">
						<recents :properties="recents"></recents>
					</v-tab>
					<v-tab :title="$t('favourites.title')">
		    		<favourites :favs="favourites" :publictoken="publicfavourite_token" v-on:openModal="openModal"></favourites>
					</v-tab>
					<v-tab :title="$t('searches.title')">
					  <searches :searches="searches" v-on:openModal="openModal"></searches>
					</v-tab>
					<!-- 
						<v-tab :title="$t('profile.title')">
						</v-tab>
					-->
				</vue-tabs>
			</div>
		</div>
	</div>
</template>

<script>
	import Recents from './recents.vue';
	import Favourites from './favourites.vue';
	import Searches from './searches.vue';
	import Welcome from './welcome.vue';
	import Modal from './modal.vue';
	import LFPortal from '../portal/portal.js'
	import { VueTabs, VTab } from 'vue-nav-tabs';

	export default {
	  name: 'app',
	  components: {
	  	Recents,
	  	Welcome,
	  	Favourites,
	  	Searches,
	  	VueTabs,
	  	VTab,
	  	Modal
	  },
	  data(){
	  	return LFPortal.dataset;
	  },
	  mounted() {
	  	// console.log('Vue.mounted');
	  	// console.log("Tabidx:%s", this.tabidx);
	  	this.$i18n.locale = this.langid;
	  },
	  updated() {
	  	// console.log('Vue.updated');
	  	this.$i18n.locale = this.langid;
	  	// We use Vue's built in change notification to trigger saving to store
	  	// This does mean that the App needs to be mounted at all times!
	  	LFPortal.save();
	  },
	  methods:{
			handleTabChange(tabIndex, newTab, oldTab){
				this.tabidx = tabIndex;
			},
			logout(){
				// console.log('Logout');
				LFPortal.logout();
			},
			openModal(data) {
      	this.modal = {
      		open: true,
      		title: data.title || '',
      		body: data.body || '',
      		code: data.code || ''
      	};
  		},
  		closeModal() {
     		this.modal = {
      		open: '',
      		title: '',
      		body: '',
      		code: ''
      	};
  		},
		}
	}
</script>



// WEBPACK FOOTER //
// src/components/App.vue